import React from 'react';
import AssignmentsList from '../AssignmentsList';

const PPEAssignmentDetailRow = ({ row, externalRefetch, onStatusChange }) => {
	const personId = row.original.person_id;
	return <AssignmentsList personId={personId} externalRefetch={externalRefetch} onStatusChange={onStatusChange} />;
};

export default PPEAssignmentDetailRow;
